import { getCategories } from '../../../data/repositories/businessRepository.js';

export const fetchCategories = () => getCategories();
